import { Switch as BaseSwitch, SwitchProps as BaseSwitchProps } from 'antd';

const Switch = (props: BaseSwitchProps) => <BaseSwitch {...props} />;

export default Switch;
